export default __webpack_public_path__ + "static/service-2-f58c8499caf2a4001b6f3d7d8f8dc493.jpg";